import React from 'react'

const ArrowUpIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M6.75 15V2.873L1.054 8.569 0 7.5 7.5 0 15 7.5l-1.054 1.07L8.25 2.872V15h-1.5Z"
    />
  </svg>
  )
}

export default ArrowUpIcon
